import { styledWithTheme } from "@amzn/stencil-react-components/context";
import { H3 } from "@amzn/stencil-react-components/text";

/**
 * A styled H3 heading that shows interactive behavior.
 */
export const StyledClickableH3 = styledWithTheme(H3)(({ theme }) => ({
  cursor: "pointer",
  color: theme.selectors.color("primary70"),
  ":hover": {
    color: theme.selectors.color("primary80"),
  },
}));
